module.exports = __webpack_public_path__ + "img/animal.281053ac.png";